import { animated, useTransition } from '@react-spring/web';
import useLineTransitionConfig from "../spring-configs/useLineTransitionConfig.js";
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
export default function AnimatedGridLines(_ref) {
  let {
    scale,
    lines,
    animationTrajectory,
    animateXOrY,
    lineKey,
    lineStyle,
    ...lineProps
  } = _ref;
  const animatedLines = useTransition(lines, {
    ...useLineTransitionConfig({
      scale,
      animateXOrY,
      animationTrajectory
    }),
    key: lineKey
  });
  return /*#__PURE__*/_jsx(_Fragment, {
    children: animatedLines((_ref2, _, _ref3) => {
      let {
        fromX,
        toX,
        fromY,
        toY,
        opacity
      } = _ref2;
      let {
        key
      } = _ref3;
      return /*#__PURE__*/_jsx(animated.line, {
        x1: fromX,
        x2: toX,
        y1: fromY,
        y2: toY,
        strokeOpacity: opacity,
        style: lineStyle,
        ...lineProps
      }, key);
    })
  });
}